/* eslint-disable react/prop-types */
import React from "react";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import picturePacient from "../../../../assets/pictures/picturePacient.jpg";
import pictureProfessional from "../../../../assets/pictures/pictureProfessional.jpg";

import "./Card.css";

export function Card({ type }) {
  const urlPortalPaciente =
    "https://hudigital.ebserh.gov.br/portalpaciente/#/login/oauth";
  const urlPortalProfissional =
    "https://hudigital.ebserh.gov.br/portalprofissional/#/login/oauth";

  function linkButtons() {
    if (type === "Paciente") window.location.replace(urlPortalPaciente);
    else {
      window.location.replace(urlPortalProfissional);
    }
  }

  return (
    <div className="cardsLandingPage">
      <div className="card">
        <p
          className={`cardTitle ${type === "Paciente" ? "Paciente" : "Profissional"}`}
        >
          {type === "Paciente" ? "PACIENTE" : "PROFISSIONAL"}
        </p>

        <img
          className="cardImage"
          alt={type === "Paciente" ? "Foto paciente" : "Foto profissional"}
          src={type === "Paciente" ? picturePacient : pictureProfessional}
        />

        <button
          className={`cardButton ${type === "Paciente" ? "Paciente" : "Profissional"}`}
          onClick={() => linkButtons()}
        >
          {type === "Paciente" ? (
            <>
              <FontAwesomeIcon
                icon={faUser}
                size="sm"
                color="#ffffff"
                style={{ marginRight: "13px" }}
              />
              <p>
                Entrar com <b>gov.br</b>
              </p>
            </>
          ) : (
            <>
              <FontAwesomeIcon
                icon={faUser}
                size="sm"
                color="#ffffff"
                style={{ marginRight: "13px" }}
              />
              <p>Acessar</p>
            </>
          )}
        </button>
      </div>
    </div>
  );
}
